import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import moment from 'moment';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';

class GuestBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      guestbookMessages: null,
      name: '',
      location: '',
      userHasLeftANote: false,
    };
    try {
      const guestbookHistory = JSON.parse(localStorage.getItem('guestbookHistory'));
      this.state.userHasLeftANote = _.get(guestbookHistory, 'userHasLeftANote');
    } catch(e) {
      // do nothing
    }
    props.setActiveComponent('Guest Book');
    this.onSubmit = this.onSubmit.bind(this);
    this.onMessageChange = this.onMessageChange.bind(this);
    this.onNameChange = this.onNameChange.bind(this);
    this.onLocationChange = this.onLocationChange.bind(this);
  }

  async refreshPosts() {
    const res = await axios.get('/api/guestbook');
    this.setState({guestbookMessages: res.data})
  }

  async onSubmit(e) {
    e.preventDefault();
    const {message, name, location} = this.state;
    if (!message || !name) {
      let falsyPiece = !message ? 'message' : 'name'
      alert(`You must enter a ${falsyPiece} to post.`)
    } else {
      await axios.post('/api/guestbook', {message, name, location});
      localStorage.setItem('guestbookHistory', JSON.stringify({userHasLeftANote: true}))
      this.refreshPosts();
      this.setState({userHasLeftANote: true});
    }
  }

  onMessageChange(e) {
    e.preventDefault();
    this.setState({message: e.target.value})
  }

  onNameChange(e) {
    e.preventDefault();
    this.setState({name: e.target.value})
  }

  onLocationChange(e) {
    e.preventDefault();
    this.setState({location: e.target.value})
  }

  async componentDidMount() {
    this.refreshPosts();
  }

  render() {
    const {guestbookMessages, name, userHasLeftANote, location} = this.state;
    return (
      <div className="guest-book">
        {!userHasLeftANote ? <div className="guest-book-editor-wrapper">
          <form onSubmit={this.onSubmit}>
            <div className="leave-a-note">Leave a note:</div>
            <textarea className="input-textarea" value={this.state.message} onChange={this.onMessageChange} />
            <div className="name-label-input-wrapper">
              <label className="name-label">Name</label>
              <input type="text" value={name} className="name-input" onChange={this.onNameChange}/>
            </div>
            <div className="location-label-input-wrapper">
              <label className="location-label">Location</label>
              <input type="text" value={location} className="location-input" onChange={this.onLocationChange}/>
            </div>
            <input type="submit" value="Submit" className="submit-button"/>
          </form>
        </div> : null}
        {guestbookMessages ? (
          <div>
            <div id="guestbook-title">Guest Book</div>
            {_.map(guestbookMessages, message => {
              let formattedTime;
              try {
                formattedTime = moment(message.time).format('MMMM Do YYYY, h:mm:ss a');
              } catch (e) {
                // do nothing
              }
              return ( message.user_name && message.message ?
                <Card className="guestbook-message" raised={true}>
                  <div className="user-name">{`${message.user_name}${message.location ? ` from ${message.location}`: ''}`}</div>
                  <div className="message-body">"{message.message}"</div>
                  <div className="message-time">{formattedTime}</div>
                </Card> : null
              )
            })}
          </div>) : null}
      </div>
    )
  }
}

export default GuestBook;
